import {IUser, User} from './user';

export interface IUserPolicyAcceptance {
  id: string;
  createdAt: string;
  updatedAt?: string;
  policyId: string;
  key: string;
  version: number;
  languageCode: string;
  acceptedAt: string;
}

export interface IProspectSubmission {
  id: string;
  createdAt: string;
  updatedAt?: string;
  externalSubmissionId: string;
  source: string;
  receivedAt: string;
  name: string;
  email: string;
  telephone: string;
  postalCode?: string | null;
  hasLand?: boolean | null;
  location?: string | null;
  locale: string;
  pagePath: string;
  preferredVisitText?: string | null;
  visitPreference?: string | null;
  modelToVisitText?: string | null;
  contactTopic?: string | null;
  message?: string | null;
  interestedModelDocumentId?: string | null;
  interestedModelCodeSnapshot?: string | null;
  interestedModelSlugSnapshot?: string | null;
  company?: string | null;
  projectLocation?: string | null;
  estimatedUnits?: number | null;
  projectStage?: string | null;
  privacyPolicyDocumentId?: string | null;
  privacyPolicyVersion?: number | null;
  privacyPolicyLocale?: string | null;
  privacyNoticeShownAt?: string | null;
  privacyPolicyTitle?: string | null;
  privacyPolicyType?: string | null;
  privacyPolicyContentHash?: string | null;
  privacyAcceptedAt?: string | null;
  marketingStatus: string;
  marketingPolicyDocumentId?: string | null;
  marketingPolicyVersion?: number | null;
  marketingPolicyLocale?: string | null;
  marketingPolicyTitle?: string | null;
  marketingPolicyType?: string | null;
  marketingPolicyContentHash?: string | null;
  marketingRequestedAt?: string | null;
  marketingConfirmedAt?: string | null;
}

export interface IProspectDetail {
  id: string;
  createdAt: string;
  updatedAt?: string;
  userId?: string;
  email: string;
  name: string;
  telephone: string;
  postalCode?: string;
  status: string;
  notes?: string;
  marketingStatus: string;
  lastInteractionAt: string;
  submissions: IProspectSubmission[];
}

export interface IIdentityDetail {
  requestedSubjectType: 'user' | 'prospect';
  requestedSubjectId: string;
  user?: IUser;
  policyAcceptances: IUserPolicyAcceptance[];
  prospects: IProspectDetail[];
}

export class IdentityDetail {
  readonly requestedSubjectType: 'user' | 'prospect';
  readonly requestedSubjectId: string;
  readonly user?: User;
  readonly policyAcceptances: IUserPolicyAcceptance[];
  readonly prospects: IProspectDetail[];

  constructor(data: IIdentityDetail) {
    this.requestedSubjectType = data.requestedSubjectType;
    this.requestedSubjectId = data.requestedSubjectId;
    this.user = data.user ? new User(data.user) : undefined;
    this.policyAcceptances = data.policyAcceptances ?? [];
    this.prospects = data.prospects ?? [];
  }

  get primaryProspect(): IProspectDetail | undefined {
    return this.prospects.find(prospect =>
      prospect.id === this.requestedSubjectId
    ) ?? this.prospects[0];
  }

  get displayName(): string {
    return this.user?.getFullName()
      ?? this.primaryProspect?.name
      ?? 'Contacto';
  }

  get email(): string {
    return this.user?.email
      ?? this.primaryProspect?.email
      ?? '';
  }

  get submissions(): IProspectSubmission[] {
    return this.prospects
      .flatMap(prospect => prospect.submissions)
      .sort((left, right) =>
        new Date(right.receivedAt).getTime() - new Date(left.receivedAt).getTime()
      );
  }
}
